import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const malShare = defineConnector({
  identifier: "malShare",
  name: "MalShare",
  tagLine: "Community malware repository",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://malshare\\.com/.*",
  auth: (app) => queryAuth([{ name: "api_key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Collect the required credentials for MalShare",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://malshare.com/documentation.php](https://malshare.com/documentation.php) to create the credential values this API expects on each request.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://malshare.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://malshare.com/api.php?action=getlist")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
